import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { withLocalize } from 'react-localize-redux';
import CreativeAsset from '../../../creativeGallery/components/creativeAsset/CreativeAsset';
import { CreativeTypes } from '../../../creativeGallery/types';
import Tooltip from '../../../components/molecules/Tooltip';
import OverflowingText from '../../../components/foundations/OverflowingText';
import { PLAYGROUND_TRANSLATIONS } from '../../consts';
import css from './CreativeResultCard.css';

const typeToCreativeType = {
    image: CreativeTypes.IMAGE,
    video: CreativeTypes.VIDEO,
    carousel: CreativeTypes.GIF,
};

const CreativeResultCard = ({ creative, translate }) => {
    const {
        url,
        type,
        dimension_result: dimensionResult,
        source,
        source_icon: sourceIcon,
        creative_name: creativeName,
    } = creative;
    const { values, error } = dimensionResult || {};

    const creativeType = typeToCreativeType[type];
    const videoRef = useRef(null);

    const renderResult = () => {
        if (error) {
            return <span className={css.errorChip}>{translate(PLAYGROUND_TRANSLATIONS.RESULT_ERROR)}</span>;
        }

        if (!values || values.length === 0) {
            return <span className={css.noResult}>No values detected</span>;
        }

        return values.map(value => (
            <span key={value} className={css.resultChip}>
                {value}
            </span>
        ));
    };

    const handleCreativeClick = () => {
        if (url) {
            window.open(url, '_blank', 'noopener,noreferrer');
        }
    };

    return (
        <div className={css.card}>
            <div className={css.creativeContainer} onClick={handleCreativeClick} role="button" tabIndex={0}>
                <CreativeAsset
                    url={url}
                    type={creativeType}
                    showCreativeTypeIndication
                    className={css.creativeAsset}
                    ref={creativeType === CreativeTypes.VIDEO ? videoRef : null}
                />
            </div>
            <div className={css.resultSection}>
                {(creativeName || sourceIcon) && (
                    <div className={css.sourceRow}>
                        {creativeName && <OverflowingText className={css.creativeName}>{creativeName}</OverflowingText>}
                        {sourceIcon && (
                            <Tooltip title={source} placement="top">
                                <img src={sourceIcon} alt={source || ''} className={css.sourceIcon} />
                            </Tooltip>
                        )}
                    </div>
                )}
                <div className={css.resultValues}>{renderResult()}</div>
            </div>
        </div>
    );
};

CreativeResultCard.propTypes = {
    creative: PropTypes.shape({
        creative_hash: PropTypes.string,
        url: PropTypes.string,
        type: PropTypes.string,
        source: PropTypes.string,
        source_icon: PropTypes.string,
        creative_name: PropTypes.string,
        dimension_result: PropTypes.shape({
            values: PropTypes.arrayOf(PropTypes.string),
            error: PropTypes.string,
        }),
    }).isRequired,
    translate: PropTypes.func.isRequired,
};

export default withLocalize(CreativeResultCard);
